import React from "react";
import { SubNavigationBar } from "./styles";
import { RangePicker } from "../../VolumeManager/styles";
import { Button } from "antd";
import ButtonGroup from "antd/lib/button/button-group";
const MultiWeekSubnavigation = ({
  openScenarioSelectModal,
  startDate,
  endDate,
  setDateRange,
  selectedScenarios,
  fromDateFilter,
  toDateFilter,
  setDateFilterRange,
  history,
}) => {
  const scenarioOnClickRedirect = ({ scenarioId, fromDate }) => {
    const routeString = `/dashboards/${scenarioId}/date/${fromDate}/range/7/offset/0`;
    history.push(routeString);
  };

  const handleOnClick = ({ scenarioId, fromDate }) =>
    scenarioOnClickRedirect({
      scenarioId,
      fromDate,
    });

  return (
    <SubNavigationBar>
      <section style={{ flexDirection: "row" }}>
        <div style={{ marginLeft: "1em" }}>
          <ButtonGroup>
            <RangePicker
              defaultValue={[startDate, endDate]}
              format="DD/MM/YYYY"
              onChange={setDateRange}
              allowClear={false}
            />
            <Button onClick={openScenarioSelectModal}>Go</Button>
          </ButtonGroup>
        </div>
        <div style={{ marginLeft: "1em" }}>
          <ButtonGroup>
            {!!selectedScenarios.length &&
              selectedScenarios.map(({ id, name, fromDate }, index) => (
                <Button
                  key={`${id}${name}${index}`}
                  onClick={() => handleOnClick({ scenarioId: id, fromDate })}
                >
                  {name}
                </Button>
              ))}
          </ButtonGroup>
        </div>
      </section>
      <section>
        <div style={{ marginRight: "1em" }}>
          <RangePicker
            defaultValue={[fromDateFilter, toDateFilter]}
            onChange={setDateFilterRange}
            format="DD/MM/YYYY"
            allowClear={false}
          />
        </div>
      </section>
    </SubNavigationBar>
  );
};

export default MultiWeekSubnavigation;
